import { createTour } from '@acre/design-system'

// Factory rather than a static tour so the copy can carry the active brand name.
const createPreviewModeTour = (brand: string) =>
  createTour({
    Button: {
      selector: '#preview-mode-tour-button',
      content: {
        title: "You're in preview mode",
        body: `This means you're using the newest version of ${brand}. Click this icon to go back to the standard mode.`,
      },
    },
  })

export default createPreviewModeTour
